
import React from "react";
import { Container, Row, Col } from "shards-react";

//import PageTitle from "../components/common/PageTitle";
import ProjectFileDetail from "../components/project-file/ProjectFileDetail";

class ProjectFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        {/* <Row noGutters className="page-header py-4">
          <PageTitle title="" subtitle="" md="12" className="ml-sm-auto mr-sm-auto" />
        </Row> */}
        <Row className="py-3">
          <Col lg="12">
            <ProjectFileDetail projectId={this.props.match.params.id} projectFileId={this.props.match.params.fid} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProjectFile;
